import * as React from "react";
import { PulseBetProgressData, PulseBetProgressPeriodData } from "../../../../data";
import { Track, TrackColors } from "../../../../components";
import { Segment } from "../Segment";
import { StaticProgressbar } from "../StaticProgressbar";

export class BetProgress extends React.Component<{
    colors: TrackColors
    segments: PulseBetProgressData
    isProgressFinished: boolean
    isGameInProgress: boolean
    callbacks?: {
        begin?: (period: PulseBetProgressPeriodData) => any
        progress?: (period: PulseBetProgressPeriodData, progress: number, time: string) => any
        complete?: (period: PulseBetProgressPeriodData) => any
    }
},
{ }> {

    renderSegments() {
        return (
            <>
            {this.props.segments.periods.map((x, i) => {
                return (
                    <Segment key={`pb-p-p${i + 1}`} time={x.startTime} index={i + 1} />
                )
            })}
            <Segment key="pb-p-p4" time={this.props.segments.endTime} index={4} />
            </>
        );
    }

    render() {
        return (
            <div className="rj-pulse-bet__progress-wrapper" >
                {!this.props.isProgressFinished
                    ? <Track start={this.props.isGameInProgress} colors={this.props.colors} segments={this.props.segments} callbacks={this.props.callbacks} />
                    : <StaticProgressbar />
                }

                {this.renderSegments()}

            </div>
        )
    }
}